import React from "react";

const VectorBanner = () => {
  return (
    <svg
      width="232"
      height="106"
      viewBox="0 0 232 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.0756 40.3671C25.4556 40.3096 25.2469 39.5485 25.6255 38.5979C26.0184 37.6016 26.9063 36.7733 27.6051 36.7536C66.9093 35.63 105.672 36.6813 143.507 39.8998C126.433 37.734 109.284 35.9179 92.3607 34.1135C64.8033 31.1911 36.3089 28.163 6.66693 29.7791C5.95401 29.8163 5.69519 29.0412 6.07605 28.0438C6.45691 27.0464 7.33684 26.2079 8.04375 26.1702C37.8303 24.5394 66.391 27.5736 94.0105 30.5111C137.259 35.1049 181.98 39.854 223.226 50.1111C223.835 50.2615 223.937 51.1628 223.45 52.1316C222.962 53.1004 222.063 53.7868 221.44 53.682C159.194 42.9135 93.4976 38.4344 26.1861 40.3586C26.15 40.3552 26.1199 40.3524 26.0837 40.3491L26.0756 40.3671Z"
        fill="#316BCB"
      />
      <path
        d="M198.93 79.3319C199.543 79.4152 200.125 78.7445 200.25 77.7648C200.385 76.739 199.968 75.7618 199.319 75.5883C162.858 65.8146 125.805 58.2101 88.5276 52.8531C105.711 54.5984 122.788 56.69 139.647 58.7423C167.091 62.0994 195.471 65.5647 222.58 73.66C223.233 73.853 223.869 73.1801 224.016 72.156C224.162 71.1318 223.758 70.1467 223.111 69.9545C195.873 61.8132 167.427 58.3391 139.917 54.9824C96.8432 49.7209 52.3028 44.2791 8.24622 44.7973C7.59576 44.8038 7.04356 45.6305 7.0117 46.6513C6.97985 47.672 7.47921 48.5182 8.12004 48.5577C72.2206 52.214 136.387 62.5612 198.83 79.2994C198.866 79.3043 198.895 79.3083 198.931 79.3132L198.93 79.3319Z"
        fill="#316BCB"
      />
    </svg>
  );
};

export default VectorBanner;
